import { render, staticRenderFns } from "./cusCotStat_V2.vue?vue&type=template&id=d745695e&"
import script from "./cusCotStat_V2.vue?vue&type=script&lang=js&"
export * from "./cusCotStat_V2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cusCotStat_V2.vue"
export default component.exports